import React from 'react';
import styled from 'styled-components';
import { SkeletonBodyText } from '@superops/ui-design-system';

const SingleLine = styled.div`
  width: ${(props) =>
    props.SingleLineWidth ? props.SingleLineWidth : '240px'};
  height: ${(props) =>
    props.SingleLineHeight ? props.SingleLineHeight : '15px'};
`;

const SkeletonTableLoading = (props) => {
  const {
    fitContentHeight = false,
    tableHeader = true,
    tableRow = 2,
    tableColumn = 4,
    borderTop,
    theme
  } = props;

  return (
    <div
      className={fitContentHeight ? '' : 'sk-table-container'}
      style={{ borderTop: borderTop ? '1px solid #dedede' : 'none' }}
    >
      {tableHeader && (
        /* Render table heade */
        <div className="fx fx-sb sk-table-head">
          {Array.from({ length: tableColumn }, (_, i) => (
            <div className="box-ch">
              <SingleLine
                className="sops-single-line flick-animation"
                SingleLineWidth="90px"
              />
            </div>
          ))}
        </div>
      )}
      {/* Render table data  */}
      {Array.from({ length: tableRow }, (_, i) => (
        <div className="fx fx-sb">
          {Array.from({ length: tableColumn }, (_, i) => (
            <div className={`box-ch ${theme ? 'themeDark' : ''}`}>
              <SkeletonBodyText size="small" lines={2} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
export default SkeletonTableLoading;
